<template>
  <div class="project_dialog">
    <div class="mask" @click="close"></div>
    <div class="content">
      <div class="content_item">
        <div class="dec_img">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) of images" :key="index">
              <img :src="item" />
            </swiper-slide>
            <div class="swiper-pagination page_text"></div>
          </swiper>
        </div>
        <div
          class="dec page_scrollbar"
          :class="[
            { dec100: show_all_text },
            { decDisplay: photo_text.length == 0 },
          ]"
        >
        <p v-html="photosText"></p>
        </div>
        <div class="dialog_btns">
          <div class="dialog_btns_left">
            <div class="swiper-button-prev button-prev" @click="slidePrev">
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Projects-弹窗"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="Page3-查看项目弹窗"
                    transform="translate(-659.000000, -787.000000)"
                    fill="#DDDDDD"
                  >
                    <g id="弹窗" transform="translate(641.000000, 254.000000)">
                      <path
                        d="M28,533 C33.5228475,533 38,537.477153 38,543 C38,548.522847 33.5228475,553 28,553 C22.4771525,553 18,548.522847 18,543 C18,537.477153 22.4771525,533 28,533 Z M29.4213426,539.842243 C29.2001066,539.608141 28.8412722,539.608141 28.6199935,539.842243 L28.6199935,539.842243 L25.9488583,542.66857 C25.9479051,542.669518 25.9471369,542.670512 25.9437368,542.673989 C25.7224581,542.908091 25.7224581,543.287815 25.9437368,543.521887 L25.9437368,543.521887 L28.614872,546.348244 C28.8361648,546.582331 29.1949851,546.582331 29.4162211,546.348244 C29.637457,546.114097 29.637457,545.734433 29.4162211,545.500346 L29.4162211,545.500346 L27.1458173,543.097998 L29.4213426,540.690126 C29.6426213,540.456054 29.6426213,540.076361 29.4213426,539.842243 Z"
                        id="icon_last_normal"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="swiper-button-next button-next" @click="slideNext">
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Projects-弹窗"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="Page3-查看项目弹窗"
                    transform="translate(-659.000000, -787.000000)"
                    fill="#DDDDDD"
                  >
                    <g id="弹窗" transform="translate(641.000000, 254.000000)">
                      <path
                        d="M28,533 C33.5228475,533 38,537.477153 38,543 C38,548.522847 33.5228475,553 28,553 C22.4771525,553 18,548.522847 18,543 C18,537.477153 22.4771525,533 28,533 Z M29.4213426,539.842243 C29.2001066,539.608141 28.8412722,539.608141 28.6199935,539.842243 L28.6199935,539.842243 L25.9488583,542.66857 C25.9479051,542.669518 25.9471369,542.670512 25.9437368,542.673989 C25.7224581,542.908091 25.7224581,543.287815 25.9437368,543.521887 L25.9437368,543.521887 L28.614872,546.348244 C28.8361648,546.582331 29.1949851,546.582331 29.4162211,546.348244 C29.637457,546.114097 29.637457,545.734433 29.4162211,545.500346 L29.4162211,545.500346 L27.1458173,543.097998 L29.4213426,540.690126 C29.6426213,540.456054 29.6426213,540.076361 29.4213426,539.842243 Z"
                        id="icon_last_normal"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div class="close_btn" @click="close">
            <span> CLOSE</span>
            <svg
              width="75px"
              height="20px"
              viewBox="0 0 75 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Projects-弹窗"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Page3-查看项目弹窗"
                  transform="translate(-1179.000000, -786.000000)"
                >
                  <g id="弹窗" transform="translate(641.000000, 254.000000)">
                    <g
                      id="icon_close"
                      transform="translate(538.000000, 532.000000)"
                    >
                      <rect
                        id="矩形"
                        fill="#DDDDDD"
                        x="0"
                        y="0"
                        width="74"
                        height="19"
                        rx="9.5"
                      ></rect>
                      <circle
                        id="椭圆形"
                        fill="#AAAAAA"
                        cx="65.5"
                        cy="9.75925926"
                        r="9.5"
                      ></circle>
                      <path
                        d="M68.8161126,7.27524817 L66.3302767,9.76105604 L68.827033,12.2578328 C69.0571395,12.4879367 69.0575651,12.8595055 68.828845,13.0882231 C68.6003072,13.3168069 68.2286856,13.3163813 67.9985791,13.0862774 L65.5017742,10.5895371 L63.0159382,13.0753571 C62.7873032,13.3039896 62.415256,13.3031261 62.1856846,13.0734965 C61.9558578,12.8437331 61.9550065,12.4716901 62.1836415,12.2430576 L64.6694775,9.75724976 L62.1727576,7.26057026 C61.9431254,7.03089199 61.9423228,6.65894623 62.1709092,6.43036242 C62.399678,6.20154756 62.7716766,6.20235017 63.0013088,6.43202843 L65.4980165,8.92870794 L67.9838159,6.4429487 C68.2127793,6.21398791 68.5843887,6.21527694 68.8142155,6.44508898 C69.0437991,6.67466996 69.0451246,7.04628738 68.8161126,7.27524817"
                        id="icon_关闭_normal"
                        fill="#FFFFFF"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["imgs", "photo_text", "imgIndex"],
  data() {
    return {
      current: "1",
      total: "6",
      show_all_text: false,
      isShow_textbtn: true,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        observer: true,
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,
        slidesPerView: 1,
        initialSlide: this.imgIndex,
      },
    };
  },
  computed: {
    photosText() {
      return this.photo_text;
    },
    images() {
      return this.imgs;
    },
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
    slidePrev() {
      if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
        this.$refs.mySwiper.$swiper.slidePrev();
      }
    },
    slideNext() {
      if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
        this.$refs.mySwiper.$swiper.slideNext();
      }
    },
  },
};
</script>

<style lang="less"  scoped>
.decDisplay {
  display: none !important;
}
.dialog_btns {
  margin-top: 21px;
}
.project_dialog {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(4, 7, 16, 0.48);
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .content {
    // height: 573px;
    width: 640px;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    transition: all 1s;
    .content_item {
      margin: 20px;
      display: flex;
      flex-direction: column;
      .dec_img {
        user-select: none;
        .swiper-slide {
          img {
            width: 100%;
            height: 400px;
            object-fit: contain;
          }
        }
        .swiper-pagination {
          position: static;
          color: #999990;
          font-size: 14px;
          text-align: center;
          margin-top: 10px;
        }
      }
      .dec {
        margin-top: 20px;
        // margin-bottom: 20px;
        width: 100%;
        font-size: 14px;
        line-height: 1.4;
        // max-height: 114px;
        // min-height: 114px;
        overflow: auto;
        user-select: none;
      }
    }
  }
  .dialog_btns {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    .dialog_btns_left {
      display: flex;
      .button-prev,
      .button-next {
        outline: none;
        &:hover {
          border: none;
          path {
            fill: #0095dd;
          }
        }
      }
      .button-next {
        svg {
          transform: rotate(180deg);
        }
      }
    }
    .close_btn {
      position: relative;
      cursor: pointer;
      color: #ffffff;
      span {
        position: absolute;
        left: 8px;
        user-select: none;
        font-size: 10px;
      }
    }
  }
}
</style>
